import React from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  onOptionChanged as onOptionChangedAction,
  onRangeChanged as onRangeChangedAction,
  queryProductFiltering,
} from '../../Actions/ProductFiltering.action';
import { translate } from '../../Services/translation';
import Button from '../Button';
import FilterCheckbox from './FilterOptions/FilterCheckbox';
import FilterRangeSlider from './FilterOptions/FilterRangeSlider';
import FilterSearchInput from './FilterSearchInput';
import { FilterGroup } from './types/FilterGroup';
import { FilterGroupOption } from './types/FilterGroupOption';
import { FilterGroupType } from './types/FilterGroupType';

interface FilterGroupFactoryAttributes {
  filter: FilterGroup;
  options: FilterGroupOption[];
  showAll?: boolean;
  showAllButtonVisible?: boolean;
  onShowHideAllClick?: Function;
  onSearch?: Function;
  onChange?: Function;
}

const FilterGroupElement = ({
  filter,
  options,
  showAll,
  showAllButtonVisible,
  onShowHideAllClick,
  onSearch,
}: FilterGroupFactoryAttributes) => {
  const dispatch = useDispatch();

  // When a filter checkbox/radiobutton is changed, this is called, which triggers a filter query
  const onOptionChanged = useCallback(
    async (filterId: string, optionId: string) => {
      dispatch(onOptionChangedAction(filterId, optionId));
      dispatch(queryProductFiltering());
    },
    [dispatch]
  );

  // When a filter range is changed, this is called, which triggers a filter query
  const onRangeChanged = useCallback(
    async (filterId: string, values: number[]) => {
      dispatch(onRangeChangedAction(filterId, values));
      dispatch(queryProductFiltering());
    },
    [dispatch]
  );

  // Renders each filter group depending on the filter group type
  const renderFilterOptions = useCallback(
    (filter: FilterGroup) => {
      switch (filter.filterGroupType) {
        case FilterGroupType.Checkbox:
          return options.map((opt) => (
            <FilterCheckbox
              filter={filter}
              option={opt}
              onChange={onOptionChanged}
              key={filter.id + opt.id}
            />
          ));
        case FilterGroupType.Range:
          return (
            <FilterRangeSlider filter={filter} onChange={onRangeChanged} />
          );
        default:
          return null;
      }
    },
    [onRangeChanged, onOptionChanged, options]
  );

  return (
    <>
      {/* {filter?.showSearch && filter.filterGroupType !== FilterGroupType.Range && filter.options && filter.options.length > 4 && (
        <FilterSearchInput filter={filter} onSearch={onSearch} />
      )} */}
      {renderFilterOptions(filter)}
      {onShowHideAllClick && showAllButtonVisible == true && (
        <Button
          btnType="outlined"
          btnSize="small"
          fullwidth={true}
          className="show-all-button"
          onClick={() => onShowHideAllClick && onShowHideAllClick(filter.id)}
        >
          {showAll
            ? translate('general.show-less')
            : translate('general.show-more')}
        </Button>
      )}
    </>
  );
};

export default FilterGroupElement;
